import React from "react";
import { Container, Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import EnrollmentChart from "../components/EnrollmentChart";
import ClassAttendanceChart from "../components/ClassAttendanceChart";
import TopStudentsList from "../components/TopStudentsList";
import FeeCollectionChart from "../components/FeeCollectionChart";
import StaffLeaveSummary from "../components/StaffLeaveSummary";
import NotificationCenter from "../components/NotificationCenter";

const AdminDashboard = () => {
  return (
    <Container fluid>
      <Row className="mb-4">
        <Col md="6">
          <Card>
            <CardBody>
              <CardTitle tag="h5">Student Enrollment</CardTitle>
              <EnrollmentChart />
            </CardBody>
          </Card>
        </Col>
        <Col md="6">
          <Card>
            <CardBody>
              <CardTitle tag="h5">Class-wise Attendance</CardTitle>
              <ClassAttendanceChart />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md="12">
          <Card>
            <CardBody>
              <CardTitle tag="h5">Top Performing Students</CardTitle>
              <TopStudentsList />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md="6">
          <Card>
            <CardBody>
              <CardTitle tag="h5">Fee Collection</CardTitle>
              <FeeCollectionChart />
            </CardBody>
          </Card>
        </Col>
        <Col md="6">
          <Card className="mb-4">
            <CardBody>
              <CardTitle tag="h5">Staff Leave Summary</CardTitle>
              <StaffLeaveSummary />
            </CardBody>
          </Card>
          <Card className="pb-2">
            <CardBody>
              <CardTitle tag="h5">Notification Center</CardTitle>
              <NotificationCenter />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminDashboard;
